import type { FC } from 'react';
import React from 'react';
import { NodeSourceHandle } from '../_base/components/node-handle';
import type { NodeProps } from '../../types';
import { NestedFlowNodeType } from './types';
import { Divider } from 'antd';

const Node: FC<NodeProps<NestedFlowNodeType>> = (props) => {
  const { data } = props;
  const { detail } = data;



  return (
    <>
      {detail.desc && (
        <div className="system-xs-regular whitespace-pre-line break-words px-3 pb-2 pt-1 text-text-tertiary">
          {detail.desc}
        </div>
      )}
    </>
  );
};

export default React.memo(Node);
